module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_11_american-village-f74d0ccac8a7bedf2a7748d9712c0530.jpg";